import React from 'react';

function Menu() {
  return (
    <>
      <p>
        <a href="#home">Home</a>
      </p>
      <p>
        <a href="#about">About</a>
      </p>
      <p>
        <a href="#contact">Contact</a>
      </p>
      <p>
        <a href="#blog">Blog</a>
      </p>
      <p>
        <a href="#careers">Careers</a>
      </p>
    </>
  );
}

export default Menu;
